import BlogHero from "../components/BlogHero";
import BlogDetails from "../components/BlogDetails";
import StructuredData from "../components/seo/StructuredData";
import Waves from "../blocks/Backgrounds/Waves/Waves";
import TheQAHubAcademyImage from "../images/TheQAHubAcademy.png";
import { useTranslation } from "../i18n";
import { blogSchema, breadcrumbSchema, organizationSchema, schemaGraph } from "../utils/seoData";
import "./Blog.css";

function Blog() {
    const { t } = useTranslation();

    return (
        <div>
            <StructuredData
                data={schemaGraph([
                    organizationSchema(TheQAHubAcademyImage),
                    blogSchema(),
                    breadcrumbSchema([
                        { name: "Inicio", url: "/" },
                        { name: "Blog", url: "/blog" },
                    ]),
                ])}
            />
            <BlogHero />
            <div className="waves-section">
                <Waves 
                    lineColor="#97b79e" 
                    backgroundColor="transparent" 
                    waveSpeedX={0.02}
                    waveSpeedY={0.005}
                    waveAmpX={25}
                    waveAmpY={10}
                    xGap={12}
                    yGap={20}
                    className="custom-waves"
                />
                <p className="waves-text">{t("blog.waves")}</p>
            </div>
            <BlogDetails />
        </div>
    );
}

export default Blog;
